import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { CompanyHttpService } from './company-http.service';
import { actions, CompanyActions } from './company.store';

@Injectable({ providedIn: 'root' })
export class CompanyEffects {
  private effect = createEffectFactory(actions, this.actions$);

  private update$ = this.effect(CompanyActions.update, ({ payload }) =>
    this.companyHttpService.update(payload),
  );

  private create$ = this.effect(CompanyActions.create, ({ payload }) =>
    this.companyHttpService.create(payload.body, payload.skipCompany).pipe(
      switchMap(company => of(CompanyActions.createSuccess({ payload: company }))),
      catchError(err => of(CompanyActions.createFailed({ payload: err }))),
    ),
  );

  private leave$ = this.effect(CompanyActions.leave, ({ payload }) =>
    this.companyHttpService.leave(payload).pipe(
      switchMap(company => of(CompanyActions.leaveSuccess({ payload: company }))),
      catchError(err => of(CompanyActions.leaveFailed({ payload: err }))),
    ),
  );

  constructor(
    private actions$: Actions,
    private companyHttpService: CompanyHttpService,
  ) {}
}
